<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Edycja numeru bramki
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-select
                                v-model="courier.gateNumberId"
                                :items="gates"
                                item-value="id"
                                outlined
                                no-data-text="Nie znaleziono numeru bramki"
                                label="Numer bramki"
                                :error-messages="courierGateNumberErrors"
                                required
                            >
                                <template slot="selection" slot-scope="data">
                                    {{ data.item.number }}
                                </template>

                                <template slot="item" slot-scope="data">
                                    {{ data.item.number }}
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zamknij"
                    :loading="actionLoading"
                    @click="saveGateNumber()"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'GateNumberDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        courierData: {
            type: Object,
            default: null
        },
        gatesData: {
            type: Array,
            default: null,
        }
    },
    data() {
        return {
            courier: {},
            actionLoading: false,
        }
    },
    validations: {
        courier: {
            gateNumberId: {
                required
            },
        }
    },
    computed: {
        gates() {
            return this.$store.state.shipments.sendings.sendings.gates
        },
        courierGateNumberErrors() {
            const errors = []

            if (!this.$v.courier.gateNumberId.$dirty) return errors
            !this.$v.courier.gateNumberId.required && errors.push('Proszę podać numer bramki.')

            return errors
        },
    },
    watch: {
        isOpen() {
            if (this.courierData === null) return
            this.courier = JSON.parse(JSON.stringify(this.courierData))
        }
    },
    methods: {
        saveGateNumber() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.actionLoading = true
            this.$store.dispatch('shipments/sendings/updateCourier', this.courier)
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.$emit('get-couriers')
                    this.onClose()
                })
        },
        onClose() {
            this.$emit('on-close')
            this.actionLoading = false
            this.$v.$reset()
            setTimeout(() => {
                this.courier = {}
            }, 500)
        },
    }
}
</script>

